// extracted by mini-css-extract-plugin
module.exports = {"matchesLinkWrapper":"RoundDetailSummer_matchesLinkWrapper_N41KM"};